import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import { Button } from 'theSource/components';
import { CardContentStyled, ActionWrapperStyled } from './TermsOfUseFormStyled';
import { PsCheckboxTuner } from 'stencilSetup';

export interface TermsOfUseFormProps {
  handleSubmit: () => void;
}

export const TermsOfUseForm = ({ handleSubmit }: TermsOfUseFormProps) => {
  const { t } = useTranslation('pages.termsofuse');
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const handleClick = (e: any) => {
    if (e.target.tagName === 'P') {
      const checkbox = document.getElementById(
        'terms-of-use-checkbox'
      ) as HTMLInputElement;
      checkbox.click();
      return;
    }

    if (e.target.tagName !== 'INPUT') {
      return;
    }

    setAgreedToTerms(!agreedToTerms);
  };

  return (
    <main data-testid="terms-of-use-form" className="mt-n3" id="mainContent">
      <div>
        <CardContentStyled>
          <h1>{t('title')}</h1>

          <div className="card  px-4 mt-1 mb-0 mt-md-5">
            <div className="mb-3">
              <a
                href="https://plansource.com/privacy-policy/"
                className="body2"
              >
                {t('privacyPolicy')}
              </a>
            </div>
            <PsCheckboxTuner
              inputId="terms-of-use-checkbox"
              name="terms-of-use-checkbox"
              checked={agreedToTerms}
              onClick={handleClick}
              rootClass="d-flex"
              labelClass="mt-0 mr-1"
              label={t('confirmationTextHtml')}
              className="d-flex"
            />
          </div>
        </CardContentStyled>
      </div>
      <ActionWrapperStyled>
        <Button
          type="button"
          variant="primary"
          label={t('common:agree')}
          disabled={!agreedToTerms}
          onClick={handleSubmit}
          data-testid="accept-button"
          sx={{ borderRadius: '55px', width: '12rem' }}
        />
      </ActionWrapperStyled>
    </main>
  );
};
